import {
  ContractedInvestigatorAmountValues,
  InvestigatorForecastValues,
  PatientVisitsValues,
  SiteContractAveragesValues,
} from '../types/investigator-forecast.types';

export const AVERAGES_SOURCE_INITIAL_VALUES: SiteContractAveragesValues = {
  averagePatientCost: 0,
  contractedSites: '',
  forecastedInvoiceables: 0,
  forecastedVisitCosts: 0,
  invoiceables: null,
  otherInvoiceablesPerc: 50,
  overheadInvoiceablesPerc: 50,
  remainingAmount: 0,
  spendToDateAmount: 0,
  totalForecastedPatients: 0,
  totalInvestigatorCosts: 0,
};

export const CONTRACTED_SOURCE_INITIAL_VALUE: ContractedInvestigatorAmountValues = {
  invoiceablesPerc: 0,
  invoiceablesToDate: 0,
  otherInvoiceables: 0,
  overheadInvoiceables: 0,
  remainingAmount: 0,
  spendToDateAmount: 0,
  totalInvestigatorCosts: 0,
  totalInvoiceables: 0,
  totalVisitCosts: 0,
  visitCostsToDate: 0,
};

export const PATIENT_VISITS_SOURCE_INITIAL_VALUE: PatientVisitsValues = {
  averageCompletedPatientCost: 0,
  avgPatientCost: 0,
  currentDiscontinuedAmount: 0,
  currentDiscontinuedPerc: 0,
  currentEnrolledAmount: 0,
  currentInvoiceablesPercent: 0,

  differentPatientCost: 0,
  forecastedRemainingInvestigatorCosts: 0,
  forecastedRemainingInvoiceables: 0,
  forecastedRemainingVisitCosts: 0,

  invoiceablesDistribution: 0,
  invoiceablesPerc: 0,

  invoiceablesToDate: 0,
  patientRemainingToDiscontinueAmount: 0,
  patientRemainingToDiscontinueAmountLeft: 0,
  remainingAmount: 0,
  remainingPatientsToDiscontinueCost: 0,

  remainingPatientsToDiscontinuePerc: 0,
  spendToDateAmount: 0,
  totalDiscontinued: 0,
  // discontinued
  totalDiscontinuedPerc: 0,
  totalForecastedInvestigatorAmountThroughEndOfTrial: 0,

  totalForecastedRemainingInvestigatorCosts: 0,
  totalInvestigatorCosts: 0,
  totalSpendToDate: 0,
  // Spend to date and remaining section
  visitCostsToDate: 0,
};

export const INITIAL_FORM_VALUES: InvestigatorForecastValues = {
  averages: AVERAGES_SOURCE_INITIAL_VALUES,
  contracted: CONTRACTED_SOURCE_INITIAL_VALUE,
  patientVisits: PATIENT_VISITS_SOURCE_INITIAL_VALUE,
  source: null,
  vendorId: null,
};
